import { ReactElement } from "react";
import FilterComponentBase from "../../../components/filterComponentBase";
import { Alert } from "@mui/material";
import { IDataContext, IFilterData, IProduction, IState } from "../../../types";
import { useSelector } from "react-redux";
import GanttChartMobile from "./ganttChartMobile";
import { useFetch } from "../../../system/useFetch";
import GanttChartParallelMachines from "./ganttChartParallelMachines";
import GanttChart from "./ganttChart";
import GanttChartMobileParallelMachine from "./ganttChartMobileParallelMachine";
import SkeletonView from "../../../components/skeletonView";


interface IProductionGanttProps {
  dataContext: IDataContext;
  parentSize: {
    width: number;
    height: number;
  };
}

const filterHeight = 50;
const pollInterval = 120000;  // 2 min

const ProductionGantt = ({ parentSize, dataContext }: IProductionGanttProps): ReactElement => {
  const filter = useSelector<IState, IFilterData>(state => state.filter);
  const { loading, error, data: productionData } = useFetch<IProduction[]>(
    {
      module: "production",
      query: "getProductionGanttByFilter",
      payload: { ...filter.remote }
    }, filter.local.mode === "REAL_TIME" ? pollInterval : 0);

  const isMobile = parentSize.width < 400 || parentSize.height < 400;

  return (
    <div className="display-flex-column">
      <FilterComponentBase loading={loading}/>
      {loading && <SkeletonView  parentSize={parentSize}/>}
      {error && <Alert severity="warning">{error.message}</Alert>}
      {!loading && !error && !productionData && <Alert severity="warning">No Data to Display.</Alert>}
      {!loading && productionData && !isMobile && dataContext.flag === "GANTT_PARALLELS" &&
      <GanttChartParallelMachines productionData={productionData}
        parentSize={{ width: parentSize.width, height: parentSize.height - filterHeight }}/>
      }
      {!loading && productionData && !isMobile && !dataContext.flag &&
      <GanttChart productionData={productionData}
        parentSize={{ width: parentSize.width, height: parentSize.height - filterHeight }}/>
      }
      {!loading && productionData && isMobile  && dataContext.flag === "GANTT_PARALLELS" &&
      <GanttChartMobileParallelMachine productionData={productionData} title={filter.remote.factoryDay ?? `${filter.remote.fromDate} - ${filter.remote.toDate}`}
        parentSize={{ width: parentSize.width, height: parentSize.height - filterHeight }}/>
      }
      {!loading && productionData && isMobile && !dataContext.flag &&
      <GanttChartMobile productionData={productionData} title={filter.remote.factoryDay ?? `${filter.remote.fromDate} - ${filter.remote.toDate}`}
        parentSize={{ width: parentSize.width, height: parentSize.height - filterHeight }}/>
      }
    </div>
  );
};

export default ProductionGantt;
